import { CustomSelect } from '@/components/form/CustomSelect';
import type { ClientEditOptions } from '@/api/clients';
import type { WizardState } from './wizardState';

/**
 * Шаг 2 — 1:1 CustomerPersonalDataLayout (Orchid). Звёздочки на фронте
 * показываются только при статусе "Активен" — сервер требует эти поля при
 * любом статусе кроме "Демо" (см. докблок ClientCreatePage.tsx и
 * validateWizardStep() в wizardState.ts): статус "Отключён" при создании —
 * редкий случай, ошибку сервера в этом случае просто покажет общий баннер на
 * последнем шаге.
 */
export function StepPersonalData({
  state,
  onChange,
  editOptions,
  fieldErrors,
}: {
  state: WizardState;
  onChange: (state: WizardState) => void;
  editOptions: ClientEditOptions | null;
  fieldErrors: string[];
}) {
  const set = <K extends keyof WizardState>(key: K, value: WizardState[K]) => {
    onChange({ ...state, [key]: value });
  };
  const invalid = (field: string) => (fieldErrors.includes(field) ? ' edit-field--invalid' : '');
  const required = state.status === 'active';

  return (
    <div className="card" style={{ maxWidth: 560 }}>
      <h2 className="detail__subtitle">Персональные данные</h2>
      <div className="edit-fields edit-fields--stacked">
        <label className="edit-field">
          <span>Шаблон соглашения</span>
          <CustomSelect
            tooltip="Шаблон соглашения"
            disabled={!editOptions}
            value={state.operatorTemplateId}
            options={[
              { value: '', label: 'По умолчанию' },
              ...(editOptions?.operatorTemplates.map((t) => ({
                value: String(t.id),
                label: t.name,
              })) ?? []),
            ]}
            onChange={(value) => set('operatorTemplateId', value)}
          />
          <span className="edit-field__hint">
            Выберите шаблон соглашения на обработку персональных данных.
          </span>
        </label>

        <label className={`edit-field${invalid('address')}`}>
          <span>Юридический адрес{required && ' *'}</span>
          <input
            type="text"
            placeholder="Индекс, город, улица, дом"
            value={state.address}
            onChange={(e) => set('address', e.target.value)}
          />
          <span className="edit-field__hint">
            Адрес будет подставлен в шаблон соглашения в переменную %ADDRESS%
          </span>
        </label>

        <label className={`edit-field${invalid('ogrn')}`}>
          <span>ОГРН{required && ' *'}</span>
          <input type="text" value={state.ogrn} onChange={(e) => set('ogrn', e.target.value)} />
          <span className="edit-field__hint">
            ОГРН будет подставлен в шаблон соглашения в переменную %OGRN%.
          </span>
        </label>
      </div>
    </div>
  );
}
